import { Spinner } from '@cian/ui-kit';
import { FC } from 'react';

import styles from './ModalLoadingContent.css';

export const ModalLoadingContent: FC = () => {
  return (
    <div className={styles['container']}>
      <Spinner color="icon-secondary-default" />
    </div>
  );
};
